import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class KnowledgeBaseItemService {
  private baseUrl = `${environment.smartPortalApiUrl}KnowledgeBaseItem`;

  constructor(private http: HttpClient) { }

  getKnowledgeBaseItem(id: any): Observable<any> {
    return this.http.get<any[]>(`${this.baseUrl}/${id}`);   
  }

  getAllKnowledgeBaseItems(): Observable<any[]> {
    return this.http.get<any[]>(`${this.baseUrl}`);
  }

  getKnowledgeBaseItemsWithoutSmalltalk(): Observable<any[]> {
    return this.http.get<any[]>(`${this.baseUrl}/no-smalltalk`);
  }

  getKnowledgeBaseItems(serviceAreaId: string): Observable<any[]> {
    return this.http.get<any[]>(`${this.baseUrl}/by-service-area/${serviceAreaId}`);
  }

  addKnowledgeBaseItem(kbItem: any): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}`, kbItem);
  }

  updateKnowledgeBaseItem(id: string, data: any): Observable<any> {
    return this.http.put<any>(`${this.baseUrl}/${id}`, data);
  }

  deleteKnowledgeBaseItem(id: any) : Observable<any> {
    return this.http.delete<any>(`${this.baseUrl}/${id}`);
  }




  moveKnowledgeBaseItem(itemId: string, targetServiceAreaId: string): Observable<any> {
    return this.http.put(`${this.baseUrl}/${itemId}/move`, { targetServiceAreaId: targetServiceAreaId });
  }

  bulkMoveKnowledgeBaseItems(itemIds: any[], bulkTargetServiceAreaId: string): Observable<any> {
    return this.http.put(`${this.baseUrl}/bulk-move`, { targetServiceAreaId: bulkTargetServiceAreaId, itemIds: itemIds })
  }



  importKnowledgeBaseItemsToServiceArea(file: File, serviceAreaId: any) : Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    
    return this.http.post(`${this.baseUrl}/import-to-service-area?serviceAreaId=${serviceAreaId}`, formData);
  }

}
